import { createApp } from 'vue';
import 'core-js/stable';
import 'regenerator-runtime';
import TopSearchForm from '@component_path/search-contents/top/top-search-form';

document.addEventListener('DOMContentLoaded', () => {
  const node = document.getElementById('top-search-form');
  const props = JSON.parse(node.getAttribute('data'));

  createApp(TopSearchForm, props).mount('#top-search-form');
});

